import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { damageTypes } from '../../../../data/receivement'
import NewBatch from './NewBatch'

const NewReceivement = () => {
  const { receivementId } = useParams()
  const [tiposAvaria] = useState(damageTypes)

  return (
    <NewBatch
      receivementId={receivementId}
      tiposAvaria={tiposAvaria}
    />
  )
}

export default NewReceivement
